<template>
  <div class="font-body text-text-primary bg-off-white min-h-screen h-full">
    <nav class="bg-yellow-500 py-4 px-8" role="navigation" aria-label="main navigation">
      <div class="flex flex-col md:flex-row justify-between items-center max-w-6xl mx-auto">
        <a href="/">
          <img class="h-8" src="../assets/images/logo/togocel.png">
        </a>
        <div class="mt-4 md:mt-0 hidden md:block">
          <div class="p-2 mx-2 cursor-pointer inline-block" role="button">
            <a class="font-semibold relative nav-link">Contact</a>
          </div>
          <div class="p-2 mx-2 cursor-pointer inline-block" role="button">
            <a class="font-semibold relative nav-link">Pricing</a>
          </div>
          <div class="p-2 mx-2 cursor-pointer inline-block" role="button">
            <a class="font-semibold relative nav-link">Sign in</a>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
  export default {
    mounted() {

      document.body.classList.remove('theme-semi-dark');
      document.body.classList.add('home-page');
    }
  }
</script>
